import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`

export const FormWrapper = styled.div`
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
  max-width: 562px;
  overflow: hidden;
  background: #fff;

  ${({ requestDone }) =>
    requestDone &&
    css`
      opacity: 0;
    `}
`
export const ResultWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 2;
`
